import { render, staticRenderFns } from "./NewTaskPanel.vue?vue&type=template&id=f0179afa&scoped=true"
import script from "./NewTaskPanel.vue?vue&type=script&lang=js"
export * from "./NewTaskPanel.vue?vue&type=script&lang=js"
import style0 from "./NewTaskPanel.vue?vue&type=style&index=0&id=f0179afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0179afa",
  null
  
)

export default component.exports